import PageHero from '../shared/PageHero.jsx';
import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { facilities } from '../constants/facilities.js';

const TONES = {
  sun: 'bg-sun shadow-[0_10px_0_rgb(20_83_45_/_0.16)]',
  mint: 'bg-mint shadow-[0_10px_0_rgb(20_83_45_/_0.13)]',
};

export default function Facilities() {
  return (
    <>
      <Seo {...metaFor('/facilities')} path="/facilities" />

      <PageHero
        eyebrow="Facilities"
        title="One campus, built and rebuilt around how children actually move."
        lede="Nothing here is decorative. Every room on this list is in use by a class this morning."
      />

      <section className="bg-cream pb-20 pt-5">
        <div className="mx-auto grid max-w-[1240px] gap-[22px] px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-3">
          {facilities.map((room, i) => (
            <Reveal
              key={room.id}
              index={i}
              as="article"
              className={[
                'overflow-hidden rounded-[28px] border-[3px] border-forest',
                room.wide ? 'sm:col-span-2' : '',
                room.tone
                  ? `p-[22px] ${TONES[room.tone]}`
                  : 'bg-white shadow-[0_10px_0_rgb(20_83_45_/_0.13)]',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {room.photoCaption && (
                <div className={room.wide ? 'aspect-16/8' : 'aspect-4/3'}>
                  <ImageSlot caption={room.photoCaption} alt={room.title} />
                </div>
              )}

              <div className={room.tone ? '' : room.wide ? 'px-6 py-5' : 'px-5 py-[18px]'}>
                <h2
                  className={`font-display font-extrabold text-forest ${
                    room.wide ? 'text-[26px]' : 'text-[23px]'
                  }`}
                >
                  {room.title}
                </h2>
                <p
                  className={`mt-1.5 leading-[1.5] ${
                    room.tone === 'sun' ? 'text-[#3d3418]' : 'text-ink-soft'
                  } ${room.wide ? 'text-[15.5px] leading-[1.55]' : 'text-[15px]'}`}
                >
                  {room.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
